import classNames from 'classnames';
import {
    Collapse,
    DropdownToggle,
    UncontrolledDropdown,
    Container,
    Badge,
} from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';

import UserDropdownMenu from './UserDropdownMenu';

function UserDropdown(props) {

    const isToggleOpen = useSelector((state) => state.toggle.isNavBarOpen);
    const updateCount = useSelector((state) => state.meta.updateCount);
    const { isAuthenticated, login } = props;

    const {
        firstName,
        lastName,
    } = useSelector((state) => ({
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
    }), shallowEqual);
    
    const firstInitial = firstName ? firstName[0] : '';
    const lastInitial = lastName ? lastName[0] : '';
    const assignedUser = firstInitial + lastInitial;
    
    return (
        <Collapse isOpen={isToggleOpen} navbar>
            <UncontrolledDropdown className="ml-auto p-3 m-2 mr-4">
                <Container className="btn btn-circle assign-circle">
                    <Badge
                        color="danger"
                        size="lg"
                        className={classNames('position-absolute', {
                            'd-none': updateCount === 0,
                        })}
                        style={{ right: '15px', top: '15px' }}>
                        {updateCount}
                    </Badge>
                    <DropdownToggle nav caret className="text-dark">
                        {assignedUser}
                    </DropdownToggle>
                    <UserDropdownMenu isAuthenticated={isAuthenticated} login={login} />
                </Container>
            </UncontrolledDropdown>
        </Collapse>
    );
}

export default UserDropdown;
